import { makeStyles, Theme } from "@material-ui/core/styles";
import { OrderSchedule } from "./index";

const paddingCard = "10px 14px";
const borderRadius = 14;

type DynamicStylesProps = Pick<OrderSchedule, "client">;

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    width: "100%",
    marginBottom: 10,
  },

  orderInfos: {
    flex: 1,
    minWidth: 0,
    padding: paddingCard,
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    backgroundColor: theme.palette.background.paper,
  },

  orderTop: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  orderOwner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  },

  collunName: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },

  ownerPhoto: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 42,
    height: 42,
    borderRadius,
    backgroundColor: theme.palette.secondary.main,
  },

  picture: {
    width: "100%",
    height: "100%",
    borderRadius,
    backgroundImage: ({ client }: DynamicStylesProps) =>
      client ? `url(${client?.picture})` : "none",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundClip: "border-box",
  },

  profileIcon: {
    height: 20,
  },

  ownerName: {
    fontSize: 16,
    fontWeight: "bold",
    marginLeft: 16,
    minWidth: 0,
  },

  ownerEnrollment: {
    fontSize: 10,
    marginLeft: 16,
    minWidth: 0,
  },

  orderTime: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginLeft: 16,
    "& span": {
      fontSize: 12,
      fontWeight: "bold",
    },
  },

  products: {
    marginTop: 8,
  },

  product: {
    display: "flex",
    flexDirection: "row",
  },

  amount: {
    flex: "0 0 33px",

    "& span": {
      fontSize: 14,
      fontWeight: "bold",
    },
  },

  name: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    "& span": {
      fontSize: 14,
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
  },

  orderAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 56px",
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    backgroundColor: "#000",
    color: "#FFF",
  },

  observation: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    justifyContent: "flex-start",
    "& span": {
      fontSize: 10,
      minWidth: 0,
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal",
    },
  },

  details: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

}));

export default useStyles;
